export interface OrdinalRecord {
  number: number;
  id: string;
}

let ordinalData: OrdinalRecord[] = [];
let isDataLoaded = false;

export const loadOrdinalData = async (): Promise<void> => {
  if (isDataLoaded) return;
  
  try {
    const response = await fetch('/rockinscriptiontonumber.json');
    if (!response.ok) {
      throw new Error('Failed to load ordinal data');
    }
    ordinalData = await response.json();
    isDataLoaded = true;
  } catch (error) {
    console.error('Error loading ordinal data:', error);
    throw error;
  }
};

export const lookupOrdinalId = (number: string): string | null => {
  const numericValue = parseInt(number, 10);
  if (isNaN(numericValue) || numericValue < 1 || numericValue > 10000) {
    return null;
  }
  
  // Convert numericValue to number for exact comparison
  const record = ordinalData.find(item => item.number === numericValue);
  return record ? record.id : null;
};

export const getOrdinalUrl = (id: string): string => {
  return `https://ord-mirror.magiceden.dev/inscription/${id}`;
};